import { SkeletonBrick, Text as TextComponent } from '@carnica/ui-kit';
import { React } from "../../libs/react";

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export var Text = function Text(props) {
  if (props.isLoading) {
    return /*#__PURE__*/React.createElement(SkeletonBrick, {
      className: props.className,
      height: 20,
      width: 200,
      "data-t-id": "components-Text"
    });
  }
  return /*#__PURE__*/React.createElement(TextComponent, props);
};